import {Component, Input} from '@angular/core';
import {ActivatedRoute, Params, QueryParamsHandling, Router} from '@angular/router';

@Component({
  selector: 'si-go-to-route-button',
  templateUrl: './go-to-route-button.component.html',
  styleUrls: ['./go-to-route-button.component.scss']
})
export class GoToRouteButtonComponent {
  @Input() tooltip: string;
  @Input() tooltipPosition = 'top';
  @Input() href: (string | number)[];
  @Input() params: Params = {};
  @Input() queryParamsHandling: QueryParamsHandling = '';
  @Input() icon: string;
  @Input() iconRight: boolean;
  @Input() text: string;
  @Input() styleClass: string;
  @Input() newTab: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  onClickButton(): void {
    event.stopPropagation();
    event.preventDefault();
    if (this.newTab) {
      const url = this.router.createUrlTree(this.href, {queryParams: this.params});
      window.open(url.toString(), '_blank');
    } else {
      this.router.navigate(this.href, {
        relativeTo: this.activatedRoute,
        queryParams: this.params,
        queryParamsHandling: this.queryParamsHandling
      });
    }
  }
}
